<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="this.arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="row mt-3">
  <div class="col">
    <mat-form-field class="mt-20 col-xs-12 field-filtre">
      <mat-label>Filter</mat-label>
      <input matInput #filterInput [formControl]="filterGenerique" />

      @if (filterGenerique.value) {
        <button mat-icon-button matSuffix aria-label="Effacer le filtre" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>
  <div class="col flex-container end align-items-center">
    <div>
      <button mat-raised-button class="bt-table-defaut bt-table-ajouter mr-5 mb-3" (click)="exportOrganigramme()">
        <mat-icon>download</mat-icon>Exporter l'organigramme
      </button>
    </div>
  </div>
</div>

<div class="optimzed mt-3">
  <app-data-table-optimized
    #directionTable
    [displayedColumns]="DirectionsDisplayedColumns"
    [getData]="loadListDirections"
    [externalFilter$]="filterSubject"
    [cellStyleCss]="demandesCellStyleCss"
    [hasView]="false"
    [hasPagination]="true"
    [selectable]="false"
    [editable]="true"
    [renewable]="false"
    [deletable]="false"
    [downloadable]="false"
    [downloadablePJ]="false"
    [downloadablePJ_hidden]="false"
    (editItemEvent)="editDirection($event)"
    >
  </app-data-table-optimized>
</div>
